import {IServiceFactory} from "../../../service-factory.interface";
import {OnlineCheckInBlockerSsr} from "../online-check-in-blocker-ssr";

export default class SvanSsrType extends OnlineCheckInBlockerSsr {
    constructor(services: IServiceFactory) {
        super('SVAN', services);
    }
}
